import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { useEffect as f } from "react";
import { useEscapeKey as v } from "../../utils/use-escape-key.js";
import { useFocusTrap as y } from "../../utils/use-focus-trap.js";
import { useScrollLock as h } from "../../utils/use-scroll-lock.js";
import { RocheUIGrid as n } from "../grid/roche-grid.js";
import { RocheUIIcon as u } from "../icon/roche-icon.js";
import { RocheUIIconButton as p } from "../icon-button/roche-icon-button.js";
import r from "./roche-overlay.module.scss.js";
const g = ({
  title: m,
  icon: t,
  closeButtonAriaLabel: s,
  isOpen: o,
  onClose: a,
  children: d
}) => {
  const c = y(o);
  return h(o), v(a, o), f(() => {
    var i;
    o && ((i = c.current) == null || i.scrollTo({ top: 0, left: 0, behavior: "auto" }));
  }, [o]), /* @__PURE__ */ l(
    "div",
    {
      ref: c,
      className: `${r.overlay} ${o ? r["overlay--open"] : ""}`,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "overlay-title",
      children: [
        /* @__PURE__ */ e("div", { className: r["overlay__sticky-header"], children: /* @__PURE__ */ e(n, { layout: "12", noPadding: !0, children: /* @__PURE__ */ l("div", { className: r.overlay__header, slot: "full", children: [
          /* @__PURE__ */ l("p", { className: r.overlay__title, id: "overlay-title", children: [
            t && /* @__PURE__ */ e(u, { icon: t, width: "24" }),
            m
          ] }),
          a && /* @__PURE__ */ e(p, { icon: "close", ariaLabel: s, onClick: a })
        ] }) }) }),
        /* @__PURE__ */ e("div", { className: r.overlay__container, children: /* @__PURE__ */ e("div", { className: r.overlay__content, children: d }) })
      ]
    }
  );
};
export {
  g as RocheUIOverlay
};
